import { Box } from '@chakra-ui/react';

export const TrendingIconUpSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <Box>
      <svg width="30" height="31" viewBox="11 11 8 9" fill="none" {...props}>
        <path
          d="M11.6665 18.8333L18.3332 12.1666"
          stroke="#2D6670"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6665 12.1666H18.3332V18.8333"
          stroke="#2D6670"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default TrendingIconUpSVG;
